export default theme => ({
    
  div: {
      // backgroundColor: 'white',
      // border: '2px solid #000',
      width: '75vw',
      // borderBottom: "1px solid #e4dede",
      [theme.breakpoints.up('xs')]: {
          width: '75vw',
      },
      [theme.breakpoints.down('sm')]: {
          width: '100vw',
      },
  },

  colorObjetivoUptime:{
    "&:hover":{
      color:"#41B900"
    }
    
  },
  colorObjetivoDowntime:{
    "&:hover":{
      color:"#C2272D"
    }
    
  },
  colorObjetivoParcial:{
    "&:hover":{
      color:"#FFC600"
    }
  },
  borderUptime:{
    "&:hover":{
      borderLeft:"8pt solid #41B900",
      borderTopLeftRadius: "10px",
      borderBottomLeftRadius:"6px"
    },

    borderLeft:"8pt solid #41B900",
    borderTopLeftRadius: "5px",
    borderBottomLeftRadius:"6px",
    width:"20%",
    padding:"0px 0px 0px 0px",
    borderTop: "0px solid #e4dede",
    borderBottom: "4px solid #e4dede"
    
  },
  
  borderParcial:{
    "&:hover":{
      borderLeft:"8pt solid #FFC600",
    },
    borderLeft:"8pt solid #FFC600",
    width:"20%",
    padding:"0px 0px 0px 0px",
    borderTop: "0px solid #e4dede",
    borderBottom: "4px solid #e4dede"
  },
  
  borderDowntime:{
    "&:hover":{
      borderLeft:"8pt solid #C2272D",
    },
    borderLeft:"8pt solid #C2272D",
    width:"20%",
    padding:"0px 0px 0px 0px",
    borderTop: "0px solid #e4dede",
    borderBottom: "4px solid #e4dede"
    
  },
  divIconUptime:{
    width:"22px", 
    height:"22px", 
    fill:"#41B900"
  },
  divIconDowntime:{
    width:"22px",
    height:"22px", 
    fill:"#C2272D"
  },
  divIconParcial:{
    width:"22px", 
    height:"22px",
    fill:" #FFC600"
  },
  stepAlign:{
    textAlign:"center",
  },
  estado:{
    //textAlign:"center",
    width:"1%",
    borderTop: "0px solid #e4dede",
    borderBottom: "4px solid #e4dede"
  },
  Tendencia:{
    textAlign:"center",
    width:"50px",
    borderTop: "0px solid #e4dede",
    borderBottom: "4px solid #e4dede"
    
  },
  alignRight:{
    textAlign:"right",
    width:"5%"
  },
  monitoreos:{
    textAlign:"center",
    width:"20%",
  },
  size90:{
    width:"20%",
    padding:"0px 0px 0px 0px"
  },
  tableCellIcon:{
    padding:"0px 0px 0px 0px",
    width:"5%",
    borderTop: "0px solid #e4dede",
    borderBottom: "4px solid #e4dede"
  },
  td:{
    padding:"4px 20px 4px 4px",
    borderTop: "0px solid #e4dede",
    borderBottom: "4px solid #e4dede"
    
  },
  first:{
    padding:"4px 20px 4px 20px"
  },
  ButtonObj:{
    fontSize:"17px",
    textAlign:"left"
  },
  tdObjective:{
    textAlign:"right",
    borderTop: "0px solid #e4dede",
    borderBottom: "4px solid #e4dede"
  },
  
  sizeText:{
    width:"365px", height:"1px", float:"right", marginTop:"5px", paddingLeft:"3px"
  },
  popover:{
    minWidth: '350px',
    [theme.breakpoints.up('md')]: {
      width: '65%',
      backgroundColor: 'red',
  },
},
popoverPorlet:{
    backgroundColor:"grey",
},
textColorPopover:{
    color:"white"
},
stopGreen:{
    color:"#41B900"
},
stopYellow:{
    color:"#FFC600"
},
atWeb:{
  color: "#FFFFFF",
  backgroundColor: "#525252",
  top:"-40%"
},
atMobile:{
  color: "#FFFFFF",
  backgroundColor: "#bd7c7c",
  top:"-40%"
},
atIvr:{
  color: "#FFFFFF",
  backgroundColor: "#514ab5bf",
  top:"-40%"
},
atMeta:{
  color: "#FFFFFF",
  backgroundColor: "#58d7ff",
  top:"-40%"
},
headerTableText:{
  fontWeight: 300,
  
},
objectiveName:{
  fontWeight: 500
},
tableRow:{
  borderTop: "0px solid #e4dede",
    borderBottom: "4px solid #e4dede"
 
},
tableCell:{
  borderTop: "0px solid #e4dede",
  borderBottom: "1px solid #e4dede"
 
 
},

updateTime:{
  fontWeight: 500,
  /* width: '200px' */
},
rounded: {
  color: '#3b3b3b',
  backgroundColor: '#fff',
  height: '30px'
},

tdSteps:{
  //padding:"4px 20px 4px 4px",
  //borderTop: "0px solid #e4dede",
  borderBottom: "4px solid #e4dede",
  //maxWidth: '10px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: "normal",
  wordWrap: "break-word"
  
},
tdTendencia:{
  //padding:"4px 20px 4px 4px",
  //borderTop: "0px solid #e4dede",
  borderBottom: "4px solid #e4dede",
  width: '2% !important',
  //textOverflow: 'ellipsis',
  //overflow: 'hidden',
  //whiteSpace: "normal",
  //wordWrap: "break-word"
  
},

});

